module.exports = __webpack_public_path__ + "static/img/3.a310ca0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/18/eng/3.png
// module id = AHxI
// module chunks = 0